import { configureStore } from '@reduxjs/toolkit';
import { createContext } from 'react';
import { createDispatchHook, createSelectorHook } from 'react-redux';

import * as middleware from './middleware';
import * as slices from './slices';

import type { ReactReduxContextValue, TypedUseSelectorHook } from 'react-redux';

export const store = configureStore({
  devTools: {
    name: '@tishman/components',
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middleware.anchorSections),
  reducer: {
    [slices.anchorSections.name]: slices.anchorSections.reducer,
    [slices.animationStates.name]: slices.animationStates.reducer,
  },
});

export const actions = {
  anchorSections: slices.anchorSections.actions,
  animationStates: slices.animationStates.actions,
};

export type AppDispatch = typeof store['dispatch'];
export type RootState = ReturnType<typeof store['getState']>;

export const Context = createContext<ReactReduxContextValue<RootState>>(
  null as unknown as ReactReduxContextValue,
);

export const useAppDispatch: () => AppDispatch = createDispatchHook(Context);
export const useAppSelector: TypedUseSelectorHook<RootState> =
  createSelectorHook(Context);
